import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "complaint-progress-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "search-section" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = {
  key: 0,
  class: "result-section"
}
const _hoisted_6 = { class: "progress-card" }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "step-title" }
const _hoisted_10 = { class: "step-time" }
const _hoisted_11 = {
  key: 0,
  class: "step-operator"
}
const _hoisted_12 = {
  key: 1,
  class: "step-remarks"
}
const _hoisted_13 = {
  key: 0,
  class: "result-card"
}
const _hoisted_14 = { class: "card-header" }
const _hoisted_15 = { class: "result-content" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_19 = {
  key: 2,
  class: "instruction-section"
}
const _hoisted_20 = { class: "instruction-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$t('progress.title'),
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_field, {
            modelValue: $setup.complaintId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.complaintId) = $event)),
            placeholder: _ctx.$t('progress.enterComplaintId'),
            clearable: "",
            maxlength: "20",
            "error-message": $setup.errorMessage
          }, {
            button: _withCtx(() => [
              _createVNode(_component_van_button, {
                size: "small",
                type: "primary",
                loading: $setup.searchLoading,
                onClick: $setup.handleSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('progress.search')), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "error-message"])
        ])
      ]),
      ($setup.complaintData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_van_cell_group, { class: "info-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_cell, {
                  "title-style": {'text-align': 'left'},
                  title: _ctx.$t('progress.complaintId'),
                  value: $setup.complaintData.code
                }, null, 8, ["title", "value"]),
                _createVNode(_component_van_cell, {
                  "title-style": {'text-align': 'left'},
                  title: _ctx.$t('progress.submitTime'),
                  value: $setup.formatDate($setup.complaintData.createdTime)
                }, null, 8, ["title", "value"]),
                _createVNode(_component_van_cell, {
                  "title-style": {'text-align': 'left'},
                  title: _ctx.$t('progress.productName'),
                  value: $setup.complaintData.productName
                }, null, 8, ["title", "value"]),
                _createVNode(_component_van_cell, {
                  "title-style": {'text-align': 'left'},
                  title: _ctx.$t('progress.description'),
                  value: $setup.complaintData.problemDescription
                }, null, 8, ["title", "value"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_icon, { name: "clock" }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('progress.progressTitle')), 1),
                _createVNode(_component_van_tag, {
                  type: $setup.getStatusType($setup.complaintData.processingStatus),
                  class: "status-tag"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.getStatusText($setup.complaintData.processingStatus)), 1)
                  ]),
                  _: 1
                }, 8, ["type"])
              ]),
              _createVNode(_component_van_steps, {
                direction: "vertical",
                active: $setup.complaintData.currentStep,
                "active-color": "#1989fa"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.complaintData.processLogs, (step) => {
                    return (_openBlock(), _createBlock(_component_van_step, {
                      key: step.id,
                      status: $setup.getStepStatus(step.step, $setup.complaintData.currentStep)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(step.actionDescription), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString($setup.formatDate(step.createdTime)), 1),
                          (step.operatorName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('progress.operator')) + ": " + _toDisplayString(step.operatorName), 1))
                            : _createCommentVNode("", true),
                          (step.remark)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(step.remark), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["status"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["active"])
            ]),
            ($setup.complaintData.status === 'completed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_van_icon, { name: "certificate" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('progress.resultTitle')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('progress.result')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString($setup.complaintData.result), 1)
                    ]),
                    ($setup.complaintData.solution)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('progress.solution')) + ":", 1),
                          _createTextVNode(" " + _toDisplayString($setup.complaintData.solution), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.complaintData.followUp)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('progress.followUp')) + ":", 1),
                          _createTextVNode(" " + _toDisplayString($setup.complaintData.followUp), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : ($setup.hasSearched && !$setup.complaintData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_van_empty, {
                description: _ctx.$t('progress.noData'),
                image: "search"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    round: "",
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {$setup.complaintId = ''; $setup.hasSearched = false})
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('progress.searchAgain')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["description"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('progress.howToUse')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('progress.instruction1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('progress.instruction3')), 1)
                ])
              ])
            ]))
    ])
  ]))
}